import type { IStorage } from "./storage.constants";
import { STORAGE } from "./storage.constants";
import { postJSON } from "./apiUtils";
import { UrlPoliciesSettings } from "@whatslly/types/integrations/UrlPoliciesSettings";
import { GetLatestUrlPolicieResponse } from "@whatslly/types/integrations/UrlPoliciesRequestsType";

export class UpdateUrlPoliciesService {
  async checkLastUpdate(storage: IStorage, fetchMethod: any, notifyUserRefreshed: () => Promise<void>) {
    const userLastUrlPoliciesUpdate = await storage.get(STORAGE.USER_URL_POLICIES_SETTINGS_UPDATE);
    const { etoken, whatsllyPod, user } = await storage.get([STORAGE.ETOKEN_KEY, STORAGE.POD_KEY, STORAGE.USER]);
    if (!etoken || etoken === "false" || !user) {
      return;
    }
    try {
      const response = await postJSON({
        urlSuffix: "/integrations/url-policies/get-latest-policies",
        pod: whatsllyPod,
        body: JSON.stringify({
          userLastUrlPoliciesUpdate,
          groupIds: user.groupIds,
        }),
        etoken,
        fetchMethod,
      });
      const body: GetLatestUrlPolicieResponse = await response.json();
      if (!body.success) return;
      await this.updatePolicies(storage, body.urlPolicies, notifyUserRefreshed);
    } catch {
      return;
    }
  }

  async updatePolicies(storage: IStorage, settings: UrlPoliciesSettings, notifyUserRefreshed: () => Promise<void>) {
    await storage.set(STORAGE.URL_POLICIES_SETTINGS, settings);
    await storage.set(STORAGE.USER_URL_POLICIES_SETTINGS_UPDATE, Date.now());
    await notifyUserRefreshed();
  }

  async removeStorageLastUrlPoliciesUpdate(storage: IStorage) {
    await storage.remove(STORAGE.USER_URL_POLICIES_SETTINGS_UPDATE);
  }

  async updateStorageLastUrlPoliciesUpdate(storage: IStorage) {
    await storage.set(STORAGE.USER_URL_POLICIES_SETTINGS_UPDATE, String(Date.now()) as unknown as number);
  }
}
export const updateUrlPoliciesService = new UpdateUrlPoliciesService();
